import {cesiumUtils} from 'vue-cesium'

export function formatCoords({latitude, longitude}) {
    function dmsToString({deg, min, sec, dir}) {
        let d;

        switch (dir) {
            case 'N':
                d = "C";
                break;
            case 'S':
                d = "Ю";
                break;
            case 'W':
                d = "З";
                break;
            case 'E':
                d = "В";
                break;
        }

        return deg + "º " + min + "' " + sec + "'' " + d + "."
    }

    function toDegrees(angle) {
        return angle * (180 / Math.PI);
    }

    return dmsToString(cesiumUtils.convertDDToDMS(toDegrees(latitude), false)) + "Ш. " +
        dmsToString(cesiumUtils.convertDDToDMS(toDegrees(longitude), true)) + "Д."
}